// extracted by mini-css-extract-plugin
module.exports = {"component":"_1ObWm1kcMLfiQTpKRnajGV"};